export default getText => key =>
  ({
    emailLabel: getText('Email address', 'Auth_Reset_Email_Form'),
    btnLabel: getText('Next', 'Auth_Reset_Email_Form'),
    errorMin: getText('Email must be at least 6 characters', 'Auth_Reset_Email_Form'),
    errorReq: getText('Email required', 'Auth_Reset_Email_Form'),
    errorValid: getText('Please enter a valid email address', 'Auth_Reset_Email_Form'),
    errorNotFound: getText('Account not found', 'Auth_Reset_Email_Form'),
  }[key])
